import { STATIC_IMAGE_URLS } from 'modules/core/constants';
import React, { FC } from 'react';

import { SearchIcon } from './styles';

interface ISearchAdornment {
  dataTestId?: string;
  onClick?: VoidFunction;
}

export const SearchAdornment: FC<ISearchAdornment> = ({ dataTestId, onClick }) => (
  <SearchIcon src={STATIC_IMAGE_URLS.icons.search} data-testid={dataTestId} onClick={onClick} />
);

export const SearchGrayAdornment: FC<ISearchAdornment> = ({ dataTestId, onClick }) => (
  <SearchIcon
    src={STATIC_IMAGE_URLS.icons.searchGray}
    data-testid={dataTestId}
    onClick={onClick}
    height="14px"
    width="14px"
  />
);
